import {Box, darken, makeStyles, Tooltip, withStyles} from "@material-ui/core";
import {TrophyIcon} from "Components/CustomIcons";

const useBingoCardPJPBarStyles = makeStyles(theme => {
    const BingoCardSettings = theme.overrides.BingoCards;

    return {
        root: {
            minHeight: 20,
            background: BingoCardSettings.pjpBarBackgroundColor,
            borderBottom: `1px solid ${darken(BingoCardSettings.pjpBarBackgroundColor, 0.2)}`,
            color: BingoCardSettings.pjpBarTextColor,
            fontWeight: theme.typography.fontWeightMedium,
            zIndex: 1,

            '& .MuiSvgIcon-root': {
                height: 16,
                margin: `0 2px`
            }
        }
    }
});

const CustomToolTip = withStyles({
    tooltip: {
        margin: 2,
    }
})(Tooltip);

const BingoCardPJPBar = ({amount = false, label = "PJP", ...rest}) => {
    const classes = useBingoCardPJPBarStyles();
    let formattedAmount;

    if (amount) {
        formattedAmount = (Number(amount)).toLocaleString(
            undefined, // leave undefined to use the visitor's browser
            // locale or a string like 'en-US' to override it.
            {minimumFractionDigits: 2}
        );
    }

    return (
        <CustomToolTip arrow title={"Jackpot Amount"}>
            <Box className={classes.root} display="flex" alignItems="center" justifyContent="center" pt={0.25} pb={0.125}
                 visibility={amount ? "visible" : "hidden"}>
                <>
                    <span>{label}</span>
                    <TrophyIcon/>
                    £{formattedAmount}
                </>
            </Box>
        </CustomToolTip>
    );
};

export default BingoCardPJPBar;
